import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AuthWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const hash = location.hash;

  useEffect(() => {
    if (
      hash.includes("error_description") &&
      !path.toLowerCase().startsWith("/auth/login")
    ) {
      try {
        const params = new URLSearchParams(hash.replace("#", "?"));
        const errorDescription = params.get("error_description");
        navigate(
          `/Auth/Login?error_description=${encodeURIComponent(
            errorDescription
          )}`,
          { replace: true }
        );
        return;
      } catch (e) {
        console.error("Failed to parse error description from URL hash:", e);
      }
    }

    if (hash.includes("access_token")) {
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.search
      );
    }
  }, [path, hash, navigate]);

  return children;
};

export default AuthWrapper;
